module.exports = __webpack_public_path__ + "img/sceneca_5.bb4d6767.png";